import React, { Component } from 'react'
import Logo from '../../components/logo/logo'

const appLogin = () => {
    return (
        <div className="dashboard" style={{ height: '550px' }}>
            <div class="bgimg">
                <div class="middle">
                    <img height={120} src={require('../../assets/images/BeelineLogoNew.png')} />
                    <br />
                    <br />
                    <h3>SORRY! NO BEELINE APP FOUND . </h3>
                    <h4>Please Try Again!</h4>
                    <hr />
                </div>
            </div>
        </div>
    )
}

export default appLogin
